import { MinorityCertificateType } from "../../sign-up/DTOs/minority-certificate-type";
import { NumberOfEmployeesOption } from "../../sign-up/DTOs/number-of-employees-option";
import { MembershipLevelOption } from "./membershipLevelOption";

export class PendingApplicationDetails {
    constructor(){
        this.membershipLevel = new MembershipLevelOption();
        this.employeeCount = new NumberOfEmployeesOption();
    }
    appId: string;
    submittedDate: string;
    companyName: string;
    employeeCount: NumberOfEmployeesOption;
    businessPhone: string;
    businessAddress: string;
    liaisonFirstName: string;
    liaisonLastName: string;
    liaisonEmail: string;
    liaisonPhone: string;
    liaisonTitle: string;
    salesperson: string;
    membershipLevel: MembershipLevelOption;
    price: number;
    paymentType: number;
    paymentTypeText: string;
    isAutoRenew: boolean;
    businessCity: string;
    businessState: string;
    businessZip: string;
    minorityCerts: MinorityCertificateType[];
    paymentAccountId: string;
    selfIdentities: string[];
    maskedPaymentString: string;
    brokerName: string;
    brokerEmail: string;
    isClosed: boolean;
    notes: string;
    status: string;
}